// Generated by scripts/generate-app-version.mjs.
export const APP_RELEASE = {
  "version": "1.0.0",
  "buildId": "20261104T021715284Z",
  "builtAt": "2026-11-04T02:17:15.284Z"
} as const;
